export const TECHNICAL_SUPPORT_TYPES = {
  PROBLEM: 'PROBLEM',
  INCIDENT: 'INCIDENT'
}